import React, { useEffect, useState } from 'react';
import {
    Box,
    Card,
    CardContent,
    Typography,
    Button,
    Grid,
    Divider,
  
    IconButton, Checkbox, Modal, TextField, Stack, Snackbar, Alert, Collapse
  } from '@mui/material';
  import baseUrl from "../config";
import axios from "axios";
import { ExpandMore, ExpandLess, } from '@mui/icons-material';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday'; // Import the specific icon
import ScheduleIcon from '@mui/icons-material/Schedule'; // Icon for status
import { CheckCircle, AccessTime } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom'; // Import useNavigate from react-router-dom

function SchedulesClass() {
    const [loading, setLoading] = useState(true);
    const [classSchedules, setClassSchedules] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [selectedSchedule, setSelectedSchedule] = useState(null);
    const [newDate, setNewDate] = useState(new Date());
    const [expandedScheduleId, setExpandedScheduleId] = useState(null);
    const [openSnackbar, setOpenSnackbar] = useState(false); 
    const navigate = useNavigate(); 
console.log(classSchedules, "classSchedules");

    const toggleExpand = (scheduleId) => {
        setExpandedScheduleId(expandedScheduleId === scheduleId ? null : scheduleId);
      };
    
      const handleRescheduleClick = (schedule) => {
        setSelectedSchedule(schedule);  // Set the schedule to reschedule
        setOpenModal(true);  // Open the modal for rescheduling
      };
    
    const handleRescheduleSubmit = async () => {
        if (!selectedSchedule) return;
    
        try {
          const { enrollmentId, _id: classScheduleId } = selectedSchedule;
    
          console.log(enrollmentId, "enrollmentId");
    
          const response = await axios.post(
            `${baseUrl}api/students/reschedule-request`,
            {
              enrollmentId,
              classScheduleId,
              newDate,
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
              },
            }
          );
          console.log('Reschedule successful:', response.data);
          setOpenSnackbar(true); // Show Snackbar on successful submission
          setOpenModal(false);  // Close the modal after successful submit
        } catch (error) {
          console.error('Error submitting reschedule request:', error);
          setOpenSnackbar(true); // Show Snackbar for error message
        }
      };
    
  
    
      const fetchClassSchedules = async () => {
        try {
          const response = await axios.get(`${baseUrl}api/students/class-schedules`, {
            headers: {
              'Authorization': `Bearer ${localStorage.getItem('token')}`,
            },
          });
          setClassSchedules(response.data);
        } catch (error) {
          console.error('Error fetching class schedules:', error);
        }
      };
    
      // Snackbar close handler
      const handleSnackbarClose = () => {
        setOpenSnackbar(false);
      };
    
      const handleAddScheduleClick = () => {
        navigate('/classsummary');
      };
    
      useEffect(() => {
        fetchClassSchedules()
      }, []);
    
    
  return (
    <>
    <Card
    sx={{
      borderRadius: 2,
      boxShadow: 3,
      overflow: 'hidden',
      backgroundColor: '#fff',
      transition: 'transform 0.3s ease',
      '&:hover': { transform: 'scale(1.05)' },
    }}
  >
    <CardContent sx={{ p: { xs: 2, md: 3 } }}>
      {/* Header Section */}
      <Box
        display="flex"
        flexDirection={{ xs: 'column', sm: 'row' }}
        justifyContent="space-between"
        alignItems={{ xs: 'flex-start', sm: 'center' }}
        gap={2}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: 600,
            color: '#1e293b',
            fontSize: { xs: '1.1rem', sm: '1.25rem' },
          }}
        >
          Class Schedules
        </Typography>
        <Button
          size="small"
          sx={{
            textTransform: 'none',
            color: '#1e293b',
            border: '2px solid #1e293b',
            '&:hover': { backgroundColor: '#e6f4f1', borderColor: '#1e293b' },
            borderRadius: 2,
            fontSize: { xs: '0.875rem', sm: '1rem' },
          }}
          onClick={handleAddScheduleClick}
        >
          All Schedule Classes
        </Button>
      </Box>

      <Divider sx={{ my: 2 }} />

      {/* Schedule List */}
      <Box>
        {classSchedules
          .filter((schedule) => new Date(schedule.startDate) > new Date())
          .slice(0, 5)
          .map((schedule, index) => (
            <>
              <Box
                key={index}
                display="flex"
                flexDirection={{ xs: 'column', sm: 'row' }}
                alignItems={{ xs: 'flex-start', sm: 'center' }}
                justifyContent="space-between"
                sx={{
                  mb: 1.5,
                  p: { xs: 2, sm: 3 },
                  borderRadius: 2,
                  backgroundColor: schedule.isRescheduleRequested ? '#f9e0b2' : '#ffffff',
                  boxShadow: 2,
                  '&:hover': {
                    boxShadow: 6,
                    backgroundColor: schedule.isRescheduleRequested ? '#fce1a1' : '#f4f4f4',
                  },
                  transition: 'all 0.3s ease',
                }}
              >
                {/* Schedule Details */}
                <Box display="flex" alignItems="center" gap={2}>
                  <AccessTime sx={{ mr: 1, fontSize: '2.0rem', color: '#1976d2' }} />
                  <Box>
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 600,
                        color: '#444',
                        fontSize: { xs: '1rem', sm: '1.1rem' },
                      }}
                    >
                      {schedule.subject} {new Date(schedule.startDate).toLocaleDateString()}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        color: '#888',
                        fontSize: { xs: '0.875rem', sm: '1rem' },
                        marginTop: 0,
                      }}
                    >
                      {schedule.time}
                    </Typography>
                  </Box>
                </Box>

                {/* Reschedule Status */}
                <Box
                  display="flex"
                  alignItems="center"
                  gap={2}
                  mt={{ xs: 2, sm: 0 }}
                >
                  {schedule.isRescheduleRequested && (
                    <Typography
                      variant="body2"
                      sx={{ color: '#d32f2f', fontWeight: 600 }}
                    >
                      Reschedule Requested
                    </Typography>
                  )}
                </Box>

                {/* Action Button */}
                <Box
                  display="flex"
                  alignItems="center"
                  gap={2}
                  mt={{ xs: 2, sm: 0 }}
                >
                  {schedule.isRescheduleRequested ? (
                    <IconButton
                      onClick={() => toggleExpand(schedule._id)}
                      sx={{ color: '#1976d2' }}
                    >
                      {expandedScheduleId === schedule._id ? <ExpandLess /> : <ExpandMore />}
                    </IconButton>
                  ) : (
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        border: '2px solid #004d40',
                        borderRadius: '50px',
                        padding: '0px 16px',
                        fontSize: '0.875rem',
                        '&:hover': { backgroundColor: '#e0f2f1' },
                        transition: 'all 0.3s ease',
                      }}
                      onClick={() => handleRescheduleClick(schedule)}
                    >
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          cursor: 'pointer',
                        }}
                      >
                        <strong>Reschedule Class</strong>
                        <IconButton
                          sx={{
                            color: '#004d40',
                            fontSize: '1.25rem',
                            marginLeft: '8px',
                          }}
                        >
                          <CalendarTodayIcon />
                        </IconButton>
                      </div>
                    </Typography>
                  )}
                </Box>
              </Box>
              <Collapse in={expandedScheduleId === schedule._id}>
                {schedule.isRescheduleRequested && (


                  <Box
                    sx={{
                      mb: 3,
                      backgroundColor: '#ffffff',
                      p: 3,
                      borderRadius: 2,
                      boxShadow: 3, // Adding depth with a smooth shadow
                      borderLeft: '5px solid #d32f2f', // Status color for visual emphasis
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        boxShadow: 6, // Darker shadow on hover to indicate interactivity
                      },
                    }}
                  >
                    {/* Header: Reschedule Requested */}
                    <Typography
                      variant="h6"
                      sx={{
                        color: '#d32f2f',
                        fontWeight: 700,
                        fontSize: '1.125rem',
                        letterSpacing: '0.5px', // Clean letter spacing
                        mb: 2,
                      }}
                    >
                      Reschedule Requested
                    </Typography>

                    {/* Original Date Section */}
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                      <CalendarTodayIcon sx={{ color: '#d32f2f', fontSize: 22, marginRight: 2 }} />
                      <Typography
                        variant="body2"
                        sx={{
                          color: '#333',
                          fontSize: '1rem',
                          fontWeight: 500,
                          opacity: 0.9
                        }}
                      >
                        <strong>Original Date:</strong> {new Date(schedule.startDate).toLocaleString()}
                      </Typography>
                    </Box>

                    {/* Rescheduled Date Section */}
                    {schedule.rescheduledDate && (
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                        <CalendarTodayIcon sx={{ color: '#004d40', fontSize: 22, marginRight: 2 }} />
                        <Typography
                          variant="body2"
                          sx={{
                            color: '#333',
                            fontSize: '1rem',
                            fontWeight: 500,
                            opacity: 0.9
                          }}
                        >
                          <strong>Rescheduled Date:</strong> {new Date(schedule.rescheduledDate).toLocaleString()}
                        </Typography>
                      </Box>
                    )}

                    {/* Status Section */}
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <ScheduleIcon sx={{ color: '#004d40', fontSize: 22, marginRight: 2 }} />
                      <Typography
                        variant="body2"
                        sx={{
                          color: '#333',
                          fontSize: '1rem',
                          fontWeight: 500,
                          opacity: 0.9
                        }}
                      >
                        <strong>Status:</strong> {schedule.rescheduleApprovalStatus}
                      </Typography>
                    </Box>
                  </Box>

                )}
              </Collapse>
            </>
          ))}
      </Box>

      {/* Modal for Rescheduling */}
      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: '90%', sm: 450 },
            bgcolor: '#f5f5f5',
            boxShadow: 24,
            p: 4,
            borderRadius: 3,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Typography
            variant="h6"
            sx={{ mb: 3, fontWeight: 600, color: '#1976d2' }}
          >
            Reschedule Class
          </Typography>
          <TextField
            label="New Date"
            type="datetime-local"
            fullWidth
            value={newDate.toISOString().slice(0, 16)}
            onChange={(e) => setNewDate(new Date(e.target.value))}
            InputLabelProps={{ shrink: true }}
            sx={{
              mb: 3,
              '& .MuiInputBase-root': {
                backgroundColor: '#fff',
                borderRadius: 1,
                borderColor: '#1976d2',
                '&:hover': { borderColor: '#115293' },
              },
              '& .MuiInputLabel-root': { color: '#1976d2' },
            }}
            InputProps={{
              sx: { padding: '10px', fontWeight: 500, color: '#1976d2' },
            }}
            helperText="Pick a date and time for rescheduling."
          />
          <Stack direction="row" spacing={2} sx={{ mt: 3 }}>
            <Button
              variant="contained"
              onClick={handleRescheduleSubmit}
              sx={{
                backgroundColor: '#1976d2',
                color: '#fff',
                '&:hover': { backgroundColor: '#115293' },
              }}
            >
              Submit
            </Button>
            <Button
              variant="outlined"
              onClick={() => setOpenModal(false)}
              sx={{
                borderColor: '#1976d2',
                color: '#1976d2',
                '&:hover': { backgroundColor: '#f5f5f5' },
              }}
            >
              Cancel
            </Button>
          </Stack>
        </Box>
      </Modal>
    </CardContent>
  </Card> 

  <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <Alert onClose={handleSnackbarClose} severity="success" sx={{ width: '100%' }}>
          Reschedule request submitted successfully!
        </Alert>
      </Snackbar>
  </>
   )
}

export default SchedulesClass